import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { LeftArrowWhite, PurpleX } from 'Images';

interface IAllFiltersModalButtons {
  resetCallback: Function;
}

export const AllFiltersModalButtons = ({
  resetCallback,
}: IAllFiltersModalButtons) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  return (
    <Stack
      direction='row'
      justifyContent={isDesktop ? 'center' : 'space-between'}
      gap={isDesktop ? '72px' : 0}
      sx={
        isDesktop
          ? {
              mt: '32px',
            }
          : {
              position: 'sticky',
              zIndex: 100,
              bottom: 0,
              left: 0,
              width: '100%',
              bgcolor: '#FFF',
              p: '12px 0',
            }
      }
    >
      <Button onClick={() => resetCallback()}>
        {isDesktop && (
          <Avatar alt='' src={PurpleX} sx={{ width: '24px', height: '24px' }} />
        )}
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textDecoration: isDesktop ? undefined : 'underline',
          }}
        >
          {dictionary.reset}
        </Typography>
      </Button>
      <Button
        variant='contained'
        type='submit'
        sx={{
          width: isDesktop ? '240px' : '162px',
          height: isDesktop ? '46px' : '40px',
          bgcolor: 'primary.shade_400',
        }}
      >
        <Typography variant='body4'>{dictionary.search}</Typography>
        <Avatar
          alt=''
          src={LeftArrowWhite}
          sx={{ height: '20px', width: '20px' }}
        />
      </Button>
    </Stack>
  );
};
